module.exports = __webpack_public_path__ + "img/section2_img.3ebed03a.svg";